export const SET_LOADING = 'SET_LOADING';
export const SET_CSRF_TOKEN = 'SET_CSRF_TOKEN';
export const ADD_ERROR = 'ADD_ERROR';

export const setLoading = loading => ({ type: SET_LOADING, loading });
export const setCsrfToken = token => ({ type: SET_CSRF_TOKEN, token });
export const addError = error => ({ type: ADD_ERROR, error });
